<template>
  <button :class="['btn', 'expand-collapse-button', sizeClass]" type="button" @click.prevent="$emit('update', !expanded)" :disabled="disabled">
    <i class="fas fa-fw fa-caret-down" v-if="!expanded"></i>
    <i class="fas fa-fw fa-caret-up" v-if="expanded"></i>
  </button>
</template>

<style scoped>
.expand-collapse-button {
  border: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0.05);
}
.expand-collapse-button:hover:enabled {
  background-color: rgba(0,0,0,0.15);
}

.theme-dark .expand-collapse-button {
  background-color: rgba(255, 255, 255, 0.05);
}
.theme-dark .expand-collapse-button:hover:enabled {
  background-color: rgba(255, 255, 255, 0.15);
}
</style>

<script>
export default {
  name: 'ExpandCollapseButton',
  model: {
    prop: 'expanded',
    event: 'update',
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    sizeClass: {
      type: String,
      default: 'btn-xs'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>